import React from "react";

import { TabViewerHorizontal } from '../TabViewer';
import HtmlViewer from "./Html/HtmlViewer";
import TextViewer from "./Text/TextViewer";

// MUI -> Arco. makeStyles -> a plain style object: every style key except
// emailViewerBody was unused dead template chrome and was dropped. The
// emailViewerBody style now flows to the viewers as a style object via
// contentStyle (the viewers apply it with `style={contentStyle}`).
const emailViewerBody = {
    minHeight: "450px",
    border: "1px solid #c2c2c2",
    padding: "10px",
    height: "100%",
    width: "100%",
};

export default function EmailViewer(props) {
    const { htmlContent, textContent, subject, classNameBody, classNameToolBar } = props;

    return (
        <TabViewerHorizontal tabs={[
            {
                name: "Html",
                component: <HtmlViewer htmlContent={htmlContent} contentStyle={emailViewerBody} />
            },
            {
                name: "Text",
                component: <TextViewer textContent={textContent} contentStyle={emailViewerBody} />
            },
        ]}></TabViewerHorizontal>
    )
}
